import React, { useEffect, useState } from "react";
import {
  Panel,
  Header,
  Section,
  Facets,
  FacetGroup,
  ResultsCount,
  ClearAll,
  FilterCount,
  ToggleButton,
  ToggleButtonLabel,
} from "./styled";

function Filters({
  className,
  activeFilters,
  results,
  isOpen,
  onToggle,
  onFilter,
  type,
  position = "right"
}) {
  const [filterCount, setFilterCount] = useState(0);

  useEffect(() => {
    let total = 0;
    Object.keys(activeFilters).forEach((x) => {
      total += activeFilters[x].length;
    });
    setFilterCount(total);
  }, [activeFilters]);

  const updateFilters = (category, filter) => {
    const filters = { ...activeFilters };
    if (!filters[category]?.includes(filter)) {
      filters[category].push(filter);
    } else {
      filters[category].splice(filters[category].indexOf(filter), 1); //deleting
    }
    onFilter(filters);
  };

  const clearFilters = () => {
    const filters = { ...activeFilters };
    Object.keys(filters).forEach((x) => {
      filters[x] = [];
    });
    onFilter(filters);
  };

  const togglePanel = () => {
    onToggle();
  };

  const facets =
    type === "awards" ? (
      <>
        <Section>
          <FacetGroup>
            <legend>Area of Interest (AOI) Category</legend>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("aoi", e.target.value);
                }}
                type="checkbox"
                value="AOI 1: Capacity Building"
                checked={activeFilters.aoi?.includes("AOI 1: Capacity Building")}
              />
              AOI 1: Capacity Building
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("aoi", e.target.value);
                }}
                type="checkbox"
                value="AOI 2: Energy Efficiency"
                checked={activeFilters.aoi?.includes("AOI 2: Energy Efficiency")}
              />
              AOI 2: Energy Efficiency
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("aoi", e.target.value);
                }}
                type="checkbox"
                value="AOI 3: Solar on Schools"
                checked={activeFilters.aoi?.includes("AOI 3: Solar on Schools")}
              />
              AOI 3: Solar on Schools
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("aoi", e.target.value);
                }}
                type="checkbox"
                value="AOI 4: Net Zero Energy Schools"
                checked={activeFilters.aoi?.includes("AOI 4: Net Zero Energy Schools")}
              />
              AOI 4: Net Zero Energy Schools
            </label>
          </FacetGroup>
        </Section>
        <Section>
          <FacetGroup>
            <legend>Decarbonizing Projects</legend>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("decarbonizingTechnology", e.target.value);
                }}
                type="checkbox"
                value="Solar"
                checked={activeFilters.decarbonizingTechnology?.includes(
                  "Solar"
                )}
              />
              Solar
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("decarbonizingTechnology", e.target.value);
                }}
                type="checkbox"
                value="Net Zero Energy (NZE) Building"
                checked={activeFilters.decarbonizingTechnology?.includes(
                  "Net Zero Energy (NZE) Building"
                )}
              />
              Net Zero Energy (NZE) Building
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("decarbonizingTechnology", e.target.value);
                }}
                type="checkbox"
                value="LEDs"
                checked={activeFilters.decarbonizingTechnology?.includes(
                  "LEDs"
                )}
              />
              LEDs
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("decarbonizingTechnology", e.target.value);
                }}
                type="checkbox"
                value="Heating Electrification"
                checked={activeFilters.decarbonizingTechnology?.includes(
                  "Heating Electrification"
                )}
              />
              Heating Electrification
            </label>
          </FacetGroup>
        </Section>
        <Section>
          <FacetGroup>
            <legend>Award Year</legend>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("awardYear", e.target.value);
                }}
                type="checkbox"
                value="2024"
                checked={activeFilters.awardYear?.includes(
                  "2024"
                )}
              />
              Fiscal Year 2024
            </label>
          </FacetGroup>
        </Section>
      </>
    ) : (
      <>
        <Section>
          <FacetGroup>
            <h3>System Size</h3>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="0-14.99"
                checked={activeFilters.systemSize?.includes("0-14.99")}
              />
              0-14.99 kW
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="15-49.99"
                checked={activeFilters.systemSize?.includes("15-49.99")}
              />
              15-49.99 kW
            </label>
            <label>
              {" "}
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="50-199.99"
                checked={activeFilters.systemSize?.includes("50-199.99")}
              />
              50-199.99 kW
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="200-499.99"
                checked={activeFilters.systemSize?.includes("200-499.99")}
              />
              200-499.99 kW
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="500"
                checked={activeFilters.systemSize?.includes("500")}
              />
              500+ kW
            </label>
            {/* <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="solar-hot-water-heater"
                checked={activeFilters.systemSize?.includes(
                  "solar-hot-water-heater"
                )}
              />
              Solar Heating and Cooling
            </label> */}
          </FacetGroup>
        </Section>
        <Section>
          <h3>Funding Type</h3>
          <FacetGroup>
            <legend>Direct Ownership</legend>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("funding", e.target.value);
                }}
                type="checkbox"
                value="Cash/Loan/Bonds"
                checked={activeFilters.funding?.includes("Cash/Loan/Bonds")}
              />
              Cash/Loan/Bond/Other
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("funding", e.target.value);
                }}
                type="checkbox"
                value="Grant/Donation/Govt Funding"
                checked={activeFilters.funding?.includes(
                  "Grant/Donation/Govt Funding"
                )}
              />
              Grant/Donation/Government Funding
            </label>
          </FacetGroup>
          <FacetGroup>
            <legend>Third Party Ownership</legend>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("funding", e.target.value);
                }}
                type="checkbox"
                value="Onsite-PPA/Lease/FIT/ESPC"
                checked={activeFilters.funding?.includes("Onsite-PPA/Lease/FIT/ESPC")}
              />
              Onsite - PPA/Lease/FIT/ESPC
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("funding", e.target.value);
                }}
                type="checkbox"
                value="Offsite-Community Solar/GreenPowerPurchase"
                checked={activeFilters.funding?.includes(
                  "Offsite-Community Solar/GreenPowerPurchase"
                )}
              />
              Offsite - Community Solar/GreenPowerPurchase
            </label>
          </FacetGroup>
          {/* <FacetGroup>
            <legend>Other</legend>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("funding", e.target.value);
                }}
                type="checkbox"
                value="Land Lease Revenue"
                checked={activeFilters.funding?.includes("Land Lease Revenue")}
              />
              Land Lease Revenue
            </label>
          </FacetGroup> */}
        </Section>
        <Section>
          <FacetGroup>
            <h3>Clean Energy Technology</h3>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("cleanEnergyTechnology", e.target.value);
                }}
                type="checkbox"
                value="Solar"
                checked={activeFilters.cleanEnergyTechnology?.includes(
                  "Solar"
                )}
              />
              Solar
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("cleanEnergyTechnology", e.target.value);
                }}
                type="checkbox"
                value="Solar + Battery Storage"
                checked={activeFilters.cleanEnergyTechnology?.includes(
                  "Solar + Battery Storage"
                )}
              />
              Solar + Battery Storage
            </label>
          </FacetGroup>
        </Section>
        <Section>
          <FacetGroup>
            <h3>Structure Type</h3>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("structureType", e.target.value);
                }}
                type="checkbox"
                value="Carport/Shade Structure"
                checked={activeFilters.structureType?.includes(
                  "Carport/Shade Structure"
                )}
              />
              Carport/Shade Structure
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("structureType", e.target.value);
                }}
                type="checkbox"
                value="Ground Mount"
                checked={activeFilters.structureType?.includes("Ground Mount")}
              />
              Ground Mount
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("structureType", e.target.value);
                }}
                type="checkbox"
                value="Rooftop/Awning"
                checked={activeFilters.structureType?.includes(
                  "Rooftop/Awning"
                )}
              />
              Rooftop/Awning
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="* Powered by a district array"
                checked={activeFilters.systemSize?.includes(
                  "* Powered by a district array"
                )}
              />
              District-Wide Array
            </label>
          </FacetGroup>
        </Section>
        {/* <Section>
  <FacetGroup>
    <h3>Case Studies</h3>
    <label>
      <input
        onChange={(e) => {
          updateFilters("caseStudies", e.target.value);
        }}
        type="checkbox"
        value="Yes"
        checked={activeFilters.caseStudies?.includes("Yes")}
      />
      Yes
    </label>
  </FacetGroup>
</Section> */}
        {/* <Section>
  <FacetGroup>
    <h3>Battery Storage</h3>

    <label>
      <input
        onChange={(e) => {
          updateFilters("batteryStorage", e.target.value);
        }}
        type="checkbox"
        value="Yes"
        checked={activeFilters.batteryStorage?.includes("Yes")}
      />
      Yes
    </label>
  </FacetGroup>
</Section> */}
      </>
    );

  return (
    <Panel className={className} isOpen={isOpen} position={position}>
      <ToggleButton onClick={togglePanel} isOpen={isOpen} position={position}>
        <ToggleButtonLabel>Filters</ToggleButtonLabel>
      </ToggleButton>
      <Header>
        <ResultsCount>
          {results?.length > 0
            ? `${results?.length} Result${results?.length > 1 ? "s" : ""}`
            : `0 Results`}
        </ResultsCount>
        <FilterCount>
          {filterCount} Filter{`${filterCount !== 1 ? "s" : ""}`} Selected
        </FilterCount>
        {filterCount > 0 && (
          <ClearAll onClick={clearFilters}>Clear All</ClearAll>
        )}
      </Header>
      <Facets>{facets}</Facets>
    </Panel>
  );
}

export default Filters;
